<div style="display: flex; flex-direction: row;">
    <label class="checkbox-container">
        <input
            class="checkbox-input"
            type="checkbox"
            readonly
            [ngModel]="checked"
        />
        <!-- (ngModelChange)="onModelChange($event)" -->
        <div class="checkbox-border">
            <div class="checkbox-filling" *ngIf="checked"></div>
        </div>
        <ng-content> </ng-content>
    </label>
</div>
